var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.48011 15.0202L8.83366 15.3738L9.18721 15.0202L16.6872 7.52022L17.0395 7.16791L16.6885 6.81437L15.5135 5.63103L15.1599 5.27498L14.8051 5.62978L8.83317 11.6017L6.19505 8.97096L5.8415 8.61839L5.48844 8.97145L4.31344 10.1464L3.95989 10.5L4.31344 10.8536L8.48011 15.0202ZM2.66699 10.5C2.66699 6.17614 6.17647 2.66667 10.5003 2.66667C14.8242 2.66667 18.3337 6.17614 18.3337 10.5C18.3337 14.8239 14.8242 18.3333 10.5003 18.3333C6.17647 18.3333 2.66699 14.8239 2.66699 10.5Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.04296ddd8f0ac93ce343d85c99087dab.svg";
export { ForwardRef as ReactComponent };